import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  subscriptionData: { data: [], currentPage: 0, totalPages: 0, totalItems: 0 },
  isFetchingSubscription: false,
  isSuccessSubscription: false,
  isErrorSubscription: false,
  errorMessageSubscription: "",

  subscriptionLoginData: {},
  isFetchingSubscriptionLogin: false,
  isSuccessSubscriptionLogin: false,
  isErrorSubscriptionLogin: false,
  errorMessageSubscriptionLogin: "",

  numberSubmissionData: {},
  isFetchingNumberSubmission: false,
  isSuccessNumberSubmission: false,
  isErrorNumberSubmission: false,
  errorMessageNumberSubmission: "",

  subscriberSubmissionData: {},
  isFetchingSubscriberSubmission: false,
  isSuccessSubscriberSubmission: false,
  isErrorSubscriberSubmission: false,
  errorMessageSubscriberSubmission: "",

  logoutData: {},
  isFetchingLogout: false,
  isSuccessLogout: false,
  isErrorLogout: false,
  errorMessageLogout: "",

  createSubscription: {},
  isSuccessCreateSubscription: false,
  isErrorCreateSubscription: false,
  errorMessageCreateSubscription: "",

  deleteSubscription: {},
  isSuccessDeleteSubscription: false,
  isErrorDeleteSubscription: false,
  errorMessageDeleteSubscription: "",

  editSubscription: {},
  isSuccessEditSubscription: false,
  isErrorEditSubscription: false,
  errorMessageEditSubscription: "",
};

export const loginSubscription = createAsyncThunk(
  "subscription/login",
  async (loginData, thunkAPI) => {
    try {
      const { username, password } = loginData;
      const { data, status } = await axios.post(
        `/subscription/login?username=${encodeURIComponent(
          username
        )}&password=${encodeURIComponent(password)}`,
        {},
        {
          headers: {
            accept: "*/*",
          },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      }
      return thunkAPI.rejectWithValue({ ...data, status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const submitNumber = createAsyncThunk(
  "subscription/submitNumber",
  async (numberData, thunkAPI) => {
    try {
      const { number, subscriptionId } = numberData;
      const { data, status } = await axios.post(
        `/subscription/Number?number=${encodeURIComponent(
          number
        )}&subscriptionId=${subscriptionId}`,
        {},
        {
          headers: {
            accept: "*/*",
          },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      }
      return thunkAPI.rejectWithValue({ ...data, status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const submitSubscriber = createAsyncThunk(
  "subscription/submitSubscriber",
  async (subscriberData, thunkAPI) => {
    try {
      const subscriptionId = subscriberData?.subscriptionId;
      const formData = new FormData();

      if (subscriberData?.firstName !== undefined && subscriberData?.firstName !== null) {
        formData.append("firstName", String(subscriberData.firstName).trim());
      }
      if (subscriberData?.lastName !== undefined && subscriberData?.lastName !== null) {
        formData.append("lastName", String(subscriberData.lastName).trim());
      }
      if (
        subscriberData?.middleName !== undefined &&
        subscriberData?.middleName !== null &&
        String(subscriberData.middleName).trim() !== ""
      ) {
        formData.append("middleName", String(subscriberData.middleName).trim());
      }
      if (subscriberData?.number !== undefined && subscriberData?.number !== null) {
        formData.append("number", String(subscriberData.number).trim());
      }
      if (subscriberData?.email !== undefined && subscriberData?.email !== null) {
        formData.append("email", String(subscriberData.email).trim());
      }
      if (subscriberData?.countryCode !== undefined && subscriberData?.countryCode !== null) {
        const cleanCountryCode = String(subscriberData.countryCode).replace(/^\+/, "").trim();
        formData.append("countryCode", cleanCountryCode);
      }
      if (
        subscriberData?.age !== undefined &&
        subscriberData?.age !== null &&
        String(subscriberData.age).trim() !== ""
      ) {
        formData.append("age", String(subscriberData.age).trim());
      }

      const { auth } = thunkAPI.getState();
      const headers = {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
      };
      if (auth?.user?.accessToken) {
        headers["Authorization"] = `Bearer ${auth.user.accessToken}`;
      }

      const response = await axios.post(
        `/subscription/subscriber?subscriptionId=${encodeURIComponent(
          subscriptionId
        )}`,
        formData,
        { headers }
      );

      const status = response.status;
      const data = response.data;

      if (String(status).startsWith("2")) {
        return { data, status };
      }
      const message =
        typeof data === "string" ? data : data?.message || data?.errorMessage;
      return thunkAPI.rejectWithValue({ message, status });
    } catch (err) {
      if (!err.response) throw err;
      const errData = err.response.data;
      const message =
        typeof errData === "string"
          ? errData
          : errData?.message || errData?.errorMessage || "Subscriber submission failed";
      return thunkAPI.rejectWithValue({
        message,
        status: err.response.status,
      });
    }
  }
);

export const logoutSubscription = createAsyncThunk(
  "subscription/logout",
  async (logoutData, thunkAPI) => {
    try {
      const { username, sessionId } = logoutData;
      let url = `/subscription/logout?username=${encodeURIComponent(username)}`;
      if (sessionId) {
        url += `&sessionId=${encodeURIComponent(String(sessionId).trim())}`;
      }
      const { data, status } = await axios.post(
        url,
        {},
        {
          headers: {
            accept: "*/*",
          },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      }
      return thunkAPI.rejectWithValue({ ...data, status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const getSubscriptionData = createAsyncThunk(
  "subscription/listSubscibeEntry",
  async (params = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const {
        pageNumber = 0,
        pageSize = 10,
        sortBy = "createdOn",
        sortDirection = "DESC",
        searchTerm,
        startDate,
        endDate,
        clientId,
        toGmt,
      } = params;

      let url = `/subscription/listSubscibeEntry?page=${pageNumber}&size=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDirection.toUpperCase()}`;
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      if (startDate) {
        let formattedStartDate = startDate;
        if (startDate.includes(" ")) {
          formattedStartDate = startDate.replace(" ", "T");
        }
        if (!formattedStartDate.includes(".")) {
          formattedStartDate = formattedStartDate.replace(/(:\d{2})$/, ":00.000");
        }
        url += `&startDate=${encodeURIComponent(formattedStartDate)}`;
      }
      if (endDate) {
        let formattedEndDate = endDate;
        if (endDate.includes(" ")) {
          formattedEndDate = endDate.replace(" ", "T");
        }
        if (!formattedEndDate.includes(".")) {
          formattedEndDate = formattedEndDate.replace(/(:\d{2})$/, ":59.999");
        }
        url += `&endDate=${encodeURIComponent(formattedEndDate)}`;
      }
      if (clientId) {
        url += `&clientId=${encodeURIComponent(clientId)}`;
      }
      if (toGmt) {
        url += `&toGmt=${encodeURIComponent(toGmt)}`;
      }

      const response = await axios.get(url, {
        headers: tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {},
      });

      const { data, status } = response;
      if (status.toString().startsWith("2")) {
        return {
          data: data.data || [],
          currentPage: data.pageNumber !== undefined ? data.pageNumber : (data.currentPage || 0),
          totalPages: data.totalPages || 0,
          totalItems: data.totalElements !== undefined ? data.totalElements : (data.totalItems || 0),
        };
      }
      return thunkAPI.rejectWithValue({ ...data, status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const addSubscriptionData = createAsyncThunk(
  "subscription/save",
  async (data, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const url = "/subscription/addSubscriptionEntry";
      const response = await axios.post(url, data, {
        headers: {
          ...(tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {}),
          "Content-Type": "multipart/form-data",
        },
      });
      if (String(response.status).startsWith("2")) {
        return response.data;
      }
      return thunkAPI.rejectWithValue({ ...response.data, status: response.status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const editSubscriptionData = createAsyncThunk(
  "subscription/edit-subscription",
  async (data, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const url = "/subscription/updateSubscribeEntry";
      const response = await axios.put(url, data, {
        headers: {
          ...(tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {}),
          "Content-Type": "multipart/form-data",
        },
      });
      if (String(response.status).startsWith("2")) {
        return response.data;
      }
      return thunkAPI.rejectWithValue({ ...response.data, status: response.status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const deleteSubscriptionData = createAsyncThunk(
  "subscription/delete-subscription",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const id = typeof udata === "object" ? udata?.id : udata;
      const headers = tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {};

      const response = await axios.delete(
        `/subscription/deleteSubscribeEntry/${id}`,
        { headers }
      );

      if (String(response.status).startsWith("2")) {
        return response.data;
      }
      return thunkAPI.rejectWithValue({ ...response.data, status: response.status });
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    clearStateSubscription: (state) => {
      state.subscriptionData = {
        data: [],
        currentPage: 0,
        totalPages: 0,
        totalItems: 0,
      };
      state.isFetchingSubscription = false;
      state.isSuccessSubscription = false;
      state.isErrorSubscription = false;
      state.errorMessageSubscription = "";
    },
    clearStateCreateSubscription: (state) => {
      state.createSubscription = {};
      state.isSuccessCreateSubscription = false;
      state.isErrorCreateSubscription = false;
      state.errorMessageCreateSubscription = "";
    },
    clearStateDeleteSubscription: (state) => {
      state.deleteSubscription = {};
      state.isSuccessDeleteSubscription = false;
      state.isErrorDeleteSubscription = false;
      state.errorMessageDeleteSubscription = "";
    },
    clearStateEditSubscription: (state) => {
      state.editSubscription = {};
      state.isSuccessEditSubscription = false;
      state.isErrorEditSubscription = false;
      state.errorMessageEditSubscription = "";
    },
    clearStateLogin: (state) => {
      state.subscriptionLoginData = {};
      state.isFetchingSubscriptionLogin = false;
      state.isSuccessSubscriptionLogin = false;
      state.isErrorSubscriptionLogin = false;
      state.errorMessageSubscriptionLogin = "";
    },
    clearStateNumberSubmission: (state) => {
      state.numberSubmissionData = {};
      state.isFetchingNumberSubmission = false;
      state.isSuccessNumberSubmission = false;
      state.isErrorNumberSubmission = false;
      state.errorMessageNumberSubmission = "";
    },
    clearStateSubscriberSubmission: (state) => {
      state.subscriberSubmissionData = {};
      state.isFetchingSubscriberSubmission = false;
      state.isSuccessSubscriberSubmission = false;
      state.isErrorSubscriberSubmission = false;
      state.errorMessageSubscriberSubmission = "";
    },
    clearStateLogout: (state) => {
      state.logoutData = {};
      state.isFetchingLogout = false;
      state.isSuccessLogout = false;
      state.isErrorLogout = false;
      state.errorMessageLogout = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // getSubscriptionData
      .addCase(getSubscriptionData.fulfilled, (state, action) => {
        state.subscriptionData = {
          data: action.payload.data || [],
          currentPage: action.payload.currentPage || 0,
          totalPages: action.payload.totalPages || 0,
          totalItems: action.payload.totalItems || 0,
        };
        state.isFetchingSubscription = false;
        state.isSuccessSubscription = true;
        state.isErrorSubscription = false;
      })
      .addCase(getSubscriptionData.pending, (state) => {
        state.isFetchingSubscription = true;
      })
      .addCase(getSubscriptionData.rejected, (state, action) => {
        state.subscriptionData = {
          data: [],
          currentPage: 0,
          totalPages: 0,
          totalItems: 0,
        };
        state.isFetchingSubscription = false;
        state.isSuccessSubscription = false;
        state.isErrorSubscription = true;
        state.errorMessageSubscription =
          action.payload?.message || "Internal error";
      })

      // addSubscriptionData
      .addCase(addSubscriptionData.fulfilled, (state, action) => {
        state.createSubscription = action.payload;
        state.isFetchingSubscription = false;
        state.isSuccessCreateSubscription = true;
        state.isErrorCreateSubscription = false;
      })
      .addCase(addSubscriptionData.pending, (state) => {
        state.isFetchingSubscription = true;
      })
      .addCase(addSubscriptionData.rejected, (state, action) => {
        state.createSubscription = {};
        state.isFetchingSubscription = false;
        state.isSuccessCreateSubscription = false;
        state.isErrorCreateSubscription = true;
        state.errorMessageCreateSubscription =
          action.payload?.message || "Internal error";
      })

      // editSubscriptionData
      .addCase(editSubscriptionData.fulfilled, (state, action) => {
        state.editSubscription = action.payload;
        state.isFetchingSubscription = false;
        state.isSuccessEditSubscription = true;
        state.isErrorEditSubscription = false;
      })
      .addCase(editSubscriptionData.pending, (state) => {
        state.isFetchingSubscription = true;
      })
      .addCase(editSubscriptionData.rejected, (state, action) => {
        state.editSubscription = {};
        state.isFetchingSubscription = false;
        state.isSuccessEditSubscription = false;
        state.isErrorEditSubscription = true;
        state.errorMessageEditSubscription =
          action.payload?.message || "Internal error";
      })

      // deleteSubscriptionData
      .addCase(deleteSubscriptionData.fulfilled, (state, action) => {
        state.deleteSubscription = action.payload;
        state.isFetchingSubscription = false;
        state.isSuccessDeleteSubscription = true;
        state.isErrorDeleteSubscription = false;
      })
      .addCase(deleteSubscriptionData.pending, (state) => {
        state.isFetchingSubscription = true;
      })
      .addCase(deleteSubscriptionData.rejected, (state, action) => {
        state.deleteSubscription = {};
        state.isFetchingSubscription = false;
        state.isSuccessDeleteSubscription = false;
        state.isErrorDeleteSubscription = true;
        state.errorMessageDeleteSubscription =
          action.payload?.message || "Internal error";
      })

      // loginSubscription
      .addCase(loginSubscription.fulfilled, (state, action) => {
        state.subscriptionLoginData = action.payload.data;
        state.isFetchingSubscriptionLogin = false;
        state.isSuccessSubscriptionLogin = true;
        state.isErrorSubscriptionLogin = false;
        state.errorMessageSubscriptionLogin = "";
      })
      .addCase(loginSubscription.pending, (state) => {
        state.isFetchingSubscriptionLogin = true;
        state.isSuccessSubscriptionLogin = false;
        state.isErrorSubscriptionLogin = false;
        state.errorMessageSubscriptionLogin = "";
      })
      .addCase(loginSubscription.rejected, (state, action) => {
        state.subscriptionLoginData = {};
        state.isFetchingSubscriptionLogin = false;
        state.isSuccessSubscriptionLogin = false;
        state.isErrorSubscriptionLogin = true;
        state.errorMessageSubscriptionLogin =
          action.payload?.message || "Invalid credentials";
      })

      // submitNumber
      .addCase(submitNumber.fulfilled, (state, action) => {
        state.numberSubmissionData = action.payload.data;
        state.isFetchingNumberSubmission = false;
        state.isSuccessNumberSubmission = true;
        state.isErrorNumberSubmission = false;
        state.errorMessageNumberSubmission = "";
      })
      .addCase(submitNumber.pending, (state) => {
        state.isFetchingNumberSubmission = true;
      })
      .addCase(submitNumber.rejected, (state, action) => {
        state.numberSubmissionData = {};
        state.isFetchingNumberSubmission = false;
        state.isSuccessNumberSubmission = false;
        state.isErrorNumberSubmission = true;
        state.errorMessageNumberSubmission =
          action.payload?.message || "Number submission failed";
      })

      // submitSubscriber
      .addCase(submitSubscriber.fulfilled, (state, action) => {
        state.subscriberSubmissionData = action.payload.data;
        state.isFetchingSubscriberSubmission = false;
        state.isSuccessSubscriberSubmission = true;
        state.isErrorSubscriberSubmission = false;
        state.errorMessageSubscriberSubmission = "";
      })
      .addCase(submitSubscriber.pending, (state) => {
        state.isFetchingSubscriberSubmission = true;
        state.isErrorSubscriberSubmission = false;
      })
      .addCase(submitSubscriber.rejected, (state, action) => {
        state.subscriberSubmissionData = {};
        state.isFetchingSubscriberSubmission = false;
        state.isSuccessSubscriberSubmission = false;
        state.isErrorSubscriberSubmission = true;
        state.errorMessageSubscriberSubmission =
          action.payload?.message || "Subscriber submission failed";
      })

      // logoutSubscription
      .addCase(logoutSubscription.fulfilled, (state, action) => {
        state.logoutData = action.payload.data;
        state.isFetchingLogout = false;
        state.isSuccessLogout = true;
        state.isErrorLogout = false;
        state.errorMessageLogout = "";
        state.subscriptionLoginData = {};
      })
      .addCase(logoutSubscription.pending, (state) => {
        state.isFetchingLogout = true;
        state.isSuccessLogout = false;
        state.isErrorLogout = false;
        state.errorMessageLogout = "";
      })
      .addCase(logoutSubscription.rejected, (state, action) => {
        state.logoutData = {};
        state.isFetchingLogout = false;
        state.isSuccessLogout = false;
        state.isErrorLogout = true;
        state.errorMessageLogout =
          action.payload?.message || "Logout failed";
      });
  },
});

export const {
  clearStateSubscription,
  clearStateCreateSubscription,
  clearStateDeleteSubscription,
  clearStateEditSubscription,
  clearStateLogin,
  clearStateNumberSubmission,
  clearStateSubscriberSubmission,
  clearStateLogout,
} = subscriptionSlice.actions;

// Aliases for convenience
export const clearLogin = () => async (dispatch) => {
  dispatch(clearStateLogin());
};
export const clearNumberSubmission = () => async (dispatch) => {
  dispatch(clearStateNumberSubmission());
};
export const clearSubscriberSubmission = () => async (dispatch) => {
  dispatch(clearStateSubscriberSubmission());
};
export const clearLogout = () => async (dispatch) => {
  dispatch(clearStateLogout());
};
export const clearState = () => async (dispatch) => {
  dispatch(clearStateSubscription());
};
export const clearStateCreate = () => async (dispatch) => {
  dispatch(clearStateCreateSubscription());
};
export const clearStateDelete = () => async (dispatch) => {
  dispatch(clearStateDeleteSubscription());
};
export const clearStateEdit = () => async (dispatch) => {
  dispatch(clearStateEditSubscription());
};

export const subscriptionSelector = (state) => state.subscription;
export default subscriptionSlice.reducer;
